import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { persistStore, persistReducer } from 'redux-persist'
import rootReducer from '../reducers/reducer'
import storage from 'redux-persist/lib/storage'
import rootSaga from '../sagas'

const sagaMiddleware = createSagaMiddleware()
const persistConfig = {
  key: 'root',
  storage,
}
const configStore = () =>
  createStore(persistReducer(persistConfig, rootReducer), applyMiddleware(sagaMiddleware))

const store = configStore()
const persistor = persistStore(store)

export { store, persistor }
sagaMiddleware.run(rootSaga)
